import { useAuth } from '../../components/provider/OIDCProvider'
import useAppSettings from './useAppSettings'
import { DUAL_ROLE_SWITCHER_FEATURE } from '../activeRole'

/**
 * Whether the persona switcher chip should render: a dual-role user with an
 * active persona, at an institution that has the DUAL_ROLE_SWITCHER feature on.
 *
 * Shared so RoleSwitcher (whether to render) and TopNav (how much top-nav width
 * to reserve for it) stay in agreement.
 */
const useShowRoleSwitcher = (): boolean => {
  const { isDualRole, activeRole } = useAuth() || {}
  const { adminSetting } = useAppSettings()
  return (
    !!isDualRole && !!activeRole && !!adminSetting?.features?.includes(DUAL_ROLE_SWITCHER_FEATURE)
  )
}

export default useShowRoleSwitcher
